import { Group } from '@mantine/core';
import { AgentSession, AgentSource } from '../../../api/events-client/events-client.type';
import { TableColumn } from '../../../components/table/table';
import { DateInput } from '../../../helpers/date-time-helpers/date-time-helpers.type';
import { secondaryLight } from '../../../styles/design-tokens';
import { Icon } from '../../../ui-library/icon/icon';
import { Text } from '../../../ui-library/typography/typography';
import { agentSourcesIcon, formatAgenticProcessDate } from '../agentic-process-helpers';

/**
 * Table columns configuration for the agentic process sessions table
 */
const getAgenticProcessSessionsTableColumns = (): TableColumn<AgentSession>[] => [
  {
    key: 'session_id',
    label: 'Session ID',
    sortable: true,
    width: '200px',
    render: (value) => (
      <Text size="small" weight="medium" style={{ fontFamily: 'monospace' }}>
        {String(value)}
      </Text>
    ),
  },
  {
    key: 'start_date',
    label: 'Session Start',
    sortable: true,
    width: '150px',
    render: (value) => <Text size="small">{formatAgenticProcessDate(value as DateInput)}</Text>,
  },
  {
    key: 'agent_source',
    label: 'Agent Source',
    sortable: true,
    width: '120px',
    render: (value) => agentSourcesIcon(value as AgentSource, 0, 12),
  },
  {
    key: 'num_events',
    label: 'Events',
    sortable: true,
    width: '80px',
    render: (value) => <Text size="small">{String(value)}</Text>,
  },
  {
    key: 'num_user_prompts',
    label: 'User Prompts',
    sortable: true,
    width: '100px',
    render: (value) => <Text size="small">{String(value)}</Text>,
  },
  {
    key: 'num_tool_calls',
    label: 'Tool Calls',
    sortable: true,
    width: '100px',
    render: (value) => <Text size="small">{String(value)}</Text>,
  },
  {
    key: 'user',
    label: 'User',
    sortable: false,
    width: '150px',
    render: (_, row) => (
      <Group gap={5} align="center">
        <Icon name="person" size={16} color={secondaryLight} />
        <Text size="small">{row.user?.name || row.user?.email || '-'}</Text>
      </Group>
    ),
  },
];

export { getAgenticProcessSessionsTableColumns };
